var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11158_7063)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11158_7063",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11158_7063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7499 17.71H19.6069C19.0765 17.71 18.5678 17.9207 18.1927 18.2958C17.8176 18.6709 17.6069 19.1796 17.6069 19.71V24.854C17.6069 25.3845 17.8176 25.8932 18.1927 26.2682C18.5678 26.6433 19.0765 26.854 19.6069 26.854H24.7499C25.2804 26.854 25.7891 26.6433 26.1641 26.2682C26.5392 25.8932 26.7499 25.3845 26.7499 24.854V19.71C26.7499 19.1796 26.5392 18.6709 26.1641 18.2958C25.7891 17.9207 25.2804 17.71 24.7499 17.71Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7499 5.14001H19.6069C19.0765 5.14001 18.5678 5.35073 18.1927 5.7258C17.8176 6.10087 17.6069 6.60958 17.6069 7.14001V12.284C17.6069 12.8144 17.8176 13.3232 18.1927 13.6982C18.5678 14.0733 19.0765 14.284 19.6069 14.284H24.7499C25.2804 14.284 25.7891 14.0733 26.1641 13.6982C26.5392 13.3232 26.7499 12.8144 26.7499 12.284V7.14001C26.7499 6.60958 26.5392 6.10087 26.1641 5.7258C25.7891 5.35073 25.2804 5.14001 24.7499 5.14001Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.393 5.14001H7.25C6.71957 5.14001 6.21086 5.35073 5.83579 5.7258C5.46071 6.10087 5.25 6.60958 5.25 7.14001V12.284C5.25 12.8144 5.46071 13.3232 5.83579 13.6982C6.21086 14.0733 6.71957 14.284 7.25 14.284H12.393C12.9234 14.284 13.4321 14.0733 13.8072 13.6982C14.1823 13.3232 14.393 12.8144 14.393 12.284V7.14001C14.393 6.60958 14.1823 6.10087 13.8072 5.7258C13.4321 5.35073 12.9234 5.14001 12.393 5.14001Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.393 17.71H7.25C6.71957 17.71 6.21086 17.9207 5.83579 18.2958C5.46071 18.6709 5.25 19.1796 5.25 19.71V24.854C5.25 25.3845 5.46071 25.8932 5.83579 26.2682C6.21086 26.6433 6.71957 26.854 7.25 26.854H12.393C12.9234 26.854 13.4321 26.6433 13.8072 26.2682C14.1823 25.8932 14.393 25.3845 14.393 24.854V19.71C14.393 19.1796 14.1823 18.6709 13.8072 18.2958C13.4321 17.9207 12.9234 17.71 12.393 17.71Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11158_7063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateServicesIcon);
export default __webpack_public_path__ + "static/media/corporateServicesIcon.7fb9f192fa0fe713977384ea2444349e.svg";
export { ForwardRef as ReactComponent };